module.exports = __webpack_public_path__ + "static/media/plugin-workspace.d3c29e3c.webp";